/* ::START::LICENCE::
Copyright eQualityTime ©2018, ©2019, ©2020, ©2021, ©2022, ©2023, ©2024, ©2025
This file is part of OVFPlayer.
OVFPlayer is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.
OVFPlayer is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.
You should have received a copy of the GNU General Public License
along with OVFPlayer.  If not, see <https://www.gnu.org/licenses/>.
::END::LICENCE:: */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProgressObject, ProgressService } from '../services/progress/progress.service';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-progress',
    templateUrl: './progress.component.html',
    styleUrls: ['./progress.component.css'],
    imports: []
})
export class ProgressComponent implements OnInit, OnDestroy {

  currentProgress: ProgressObject = ProgressService.message('Loading');
  private subscription: Subscription;

  constructor(private progressSerivce: ProgressService) { }

  ngOnInit() {
    this.subscription = this.progressSerivce.getProgress().subscribe(this.updateProgress);
  }

  private updateProgress = (progress: ProgressObject) => {
    this.currentProgress = progress;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
